import { render, staticRenderFns } from "./WorkDetail13.vue?vue&type=template&id=0d3ccbc8&scoped=true&"
import script from "./WorkDetail13.vue?vue&type=script&lang=js&"
export * from "./WorkDetail13.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail13.vue?vue&type=style&index=0&id=0d3ccbc8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ccbc8",
  null
  
)

export default component.exports